<template>
  <div class="companies-cards has-background-light scrolleable-horizontal">
    <div class="company-card box is-flex is-align-items-center is-justify-content-center"
      v-for="(company, index) in companies"
      :style="`background-color:${company.mainColor};`"
      :id="index"
      :key="`company-${index}`"
      @click="getCompanyVacancies(company)"
      >
      <img :src="company.logo.url" alt="" class="company-logo" v-if="company.logo">
      <p v-else class="has-text-light company-logo is-size-3 has-text-weight-semibold">{{ company.name }}</p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    companies: {
      default: null,
      required: true
    }
  },
  methods: {
    getCompanyVacancies(company) {
      this.$emit('companySelected', company)
    }
  },
  computed: {
  }
}
</script>

<style lang="scss" scoped>
.companies-cards{
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: flex-start;
  align-content: flex-start;
  width: 100%;
  min-height: fit-content;
  max-height: 100%;
  gap: 12px;
  padding: 1rem;
  border-radius: 10px;
}

@media screen and (max-width: 768px) {
  .companies-container {
    max-width: 80%;
    padding: 1rem;
  }
}

.company-card {
  min-width: 12rem;
  max-width: 12rem;
  min-height: 7rem;
  max-height: 7rem;

  border-radius: 5px;
  text-align: center;
  padding: 0 1rem;
  margin: 0 !important;
}

.company-logo {
  max-height: 100%;
  max-width: 100%;
  transition: transform 250ms;
}

.company-card:hover {
  transform: scale(1.1);
  cursor: pointer
}
</style>
